import styled, { css } from "styled-components";
import { getIsWebView } from "../../utils/webView";

export const StyledNav = styled.nav`
  position: relative;
  display: flex;
  min-width: 0;
  white-space: nowrap;
  background-color: ${({ theme }) => theme.colors.white8};
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  z-index: 2;

  ${
    getIsWebView() &&
    css`
      width: 100%;
    `
  }
`;

export const StyledUL = styled.ul`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.space[1]};
  margin: 0;
  padding: 0;
  white-space: nowrap;
  list-style: none;
  overflow-x: scroll;
  overflow-y: hidden;
  scrollbar-width: none; /* Firefox */
  -ms-overflow-style: none; /* Edge */

  &::-webkit-scrollbar {
    display: none; /* Chrome/Safari */
  }
`;

export const NavContainer = styled.div`
  max-width: 1220px;
  margin: 0 auto;
  width: 100%;
  min-width: 0;
  padding: ${({ theme }) => `0 ${theme.space[2]}`};
`;
